import { initHorizontalScroll } from './horizontal-scroll.js';
import { mobileScroll } from './content.js';

// 説明欄とカードを一緒に留め、左端へ到達したカードを既存の選択処理へ渡す。
export function initTopicScroll(hold, lenis, { mobile, scroller = window, select, reducedMotion }) {
  const content = hold.querySelector('.submv-content');
  const copy = hold.querySelector('.sub-copy');
  const track = hold.querySelector('.topics');
  const viewport = hold.querySelector('.topics-viewport');
  const cards = [...track.querySelectorAll('article')];
  const controls = hold.querySelector('.topic-controls');
  const previous = controls.querySelector('[data-topic-previous]');
  const next = controls.querySelector('[data-topic-next]');
  const count = controls.querySelector('[data-topic-count]');
  let horizontal;
  let selected;
  let anchorHeight;
  let measuredWidth;
  let measuredHeight;
  const update = ({ position }) => {
    let index = 0;
    cards.forEach((card, candidate) => {
      if (card.offsetLeft - cards[0].offsetLeft <= position + .5) index = candidate;
    });
    const label = `${String(index + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
    if (count.textContent !== label) count.textContent = label;
    previous.disabled = position <= .5;
    next.disabled = position >= cards.at(-1).offsetLeft - cards[0].offsetLeft - .5;
    const start = horizontal?.getScrollPosition(0);
    if (start === undefined || lenis.scroll < start - 1) {
      selected = undefined;
      return;
    }
    if (selected === index) return;
    // 左端付近の丸め・微小な戻りで同じ2枚を選び直さない。
    if (selected !== undefined && index < selected
      && position >= cards[selected].offsetLeft - cards[0].offsetLeft - 8) return;
    selected = index;
    select(cards[index].querySelector('[data-topic]').dataset.topic);
  };
  const refresh = () => {
    if (!mobile.matches) {
      horizontal?.destroy();
      horizontal = null;
      selected = undefined;
      anchorHeight = undefined;
      hold.classList.remove('is-topics-horizontal');
      controls.hidden = true;
      lenis.resize();
      return;
    }
    hold.classList.add('is-topics-horizontal');
    controls.hidden = false;
    const height = scroller === window ? window.innerHeight : scroller.clientHeight;
    if (anchorHeight === undefined || selected === undefined || measuredWidth !== viewport.clientWidth || measuredHeight !== height) {
      anchorHeight = content.offsetHeight;
      measuredWidth = viewport.clientWidth;
      measuredHeight = height;
    }
    if (horizontal) horizontal.refresh();
    else horizontal = initHorizontalScroll(hold, {
      lenis, scroller, stickyElement: content,
      viewportWidth: () => viewport.clientWidth,
      holdPositions: () => cards.map((card) => card.offsetLeft - cards[0].offsetLeft),
      holdDistance: () => (scroller === window ? window.innerHeight : scroller.clientHeight) * mobileScroll.cardHoldVh / 100,
      // 内容の下端をスクロール枠の下端に揃えて留める。
      stickyTop: () => (scroller === window ? window.innerHeight : scroller.clientHeight) - content.offsetHeight,
      // 説明の行数が変わっても横位置の基準は動かさず、下端固定だけ再計測する。
      startOffset: () => anchorHeight - content.offsetHeight,
      onUpdate: update,
    });
  };
  const moveTo = (index) => {
    if (!horizontal || lenis.isStopped || index < 0 || index >= cards.length) return;
    lenis.scrollTo(horizontal.getScrollPosition(cards[index].offsetLeft - cards[0].offsetLeft), {
      duration: .65, immediate: reducedMotion.matches,
    });
  };
  const move = (direction) => {
    if (!horizontal) return;
    const { position } = horizontal.getState();
    const positions = cards.map((card) => card.offsetLeft - cards[0].offsetLeft);
    moveTo(direction > 0
      ? positions.findIndex((value) => value > position + .5)
      : positions.findLastIndex((value) => value < position - .5));
  };
  const onPrevious = () => move(-1);
  const onNext = () => move(1);
  const onClick = (event) => {
    if (event.defaultPrevented) return;
    const index = cards.findIndex((card) => card.contains(event.target));
    moveTo(index);
  };
  const onFocus = (event) => {
    if (event.target.matches?.(':focus-visible')) onClick(event);
  };
  const observer = new ResizeObserver(refresh);
  observer.observe(content);
  observer.observe(copy);
  observer.observe(viewport);
  if (scroller !== window) observer.observe(scroller);
  mobile.addEventListener('change', refresh);
  track.addEventListener('click', onClick);
  track.addEventListener('focusin', onFocus);
  previous.addEventListener('click', onPrevious);
  next.addEventListener('click', onNext);
  refresh();
  return () => {
    observer.disconnect();
    mobile.removeEventListener('change', refresh);
    track.removeEventListener('click', onClick);
    track.removeEventListener('focusin', onFocus);
    previous.removeEventListener('click', onPrevious);
    next.removeEventListener('click', onNext);
    horizontal?.destroy();
    hold.classList.remove('is-topics-horizontal');
    controls.hidden = true;
  };
}
